import Vue from "vue";
import Router from "vue-router";
import routes from "./routes";

Vue.use(Router);

// scrollBehavior
const scrollBehavior = (to, from, savedPosition) => {
  let position = { x: 0, y: 0 };
  // Keep scroll position when using browser buttons
  if (savedPosition) {
    position = savedPosition;
  }

  // Workaround for transitions scrolling to the top of the page
  // However, there are still some problems being fixed by the vue team
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(position);
    }, 1000);
  });
};

const router = new Router({
  mode: "hash",
  base: process.env.BASE_URL,
  scrollBehavior: scrollBehavior,
  routes,
});

export default router;
